import { Container } from "react-bootstrap";
import elec1 from "../../../assets/images/electrical1.png";
import eng1 from "../../../assets/images/eng12.png";
import fir1 from "../../../assets/images/fir12.png";
import build1 from "../../../assets/images/build12.png";
import plumb1 from "../../../assets/images/plumb12.png";
import line from "../../../assets/images/line.png";
import styles from "../six/six.module.scss";

const Six = () => {
  return (
    <div id="category" className={styles.wrapper}>
      <Container>
        <div className={styles.main_wrapper}>
          <div className={styles.heading}>
            <p className={styles.head}>
              <img src={line} /> Categories <img src={line} />
            </p>
            <span>
              Fulfilling all of your construction code
              <br /> inspection needs
            </span>
          </div>
          <div className={styles.main}>
            <div className={styles.main_card}>
              <img className={styles.short_img} src={elec1} />
              <div className={styles.elec}>
                <p>Electrical</p>
                <ul>
                  <li>Rough Electric & Service</li>
                  <li>Final Electric</li>
                </ul>
              </div>
            </div>
            <div className={styles.main_card}>
              <img className={styles.short_img} src={eng1} />
              <div className={styles.elec}>
                <p>Engineering</p>
                <ul>
                  <li>Frame</li>
                  <li>Insulation</li>
                </ul>
              </div>
            </div>
            <div className={styles.main_card}>
              <img className={styles.short_img} src={fir1} />
              <div className={styles.elec}>
                <p>Fire</p>
                <ul>
                  <li>Final Fire</li>
                  <li>Rough Fire</li>
                </ul>
              </div>
            </div>
            <div className={styles.main_card}>
              <img className={styles.short_img} src={build1} />
              <div className={styles.elec}>
                <p>Building</p>
                <ul>
                  <li>Slab</li>
                  <li>Sheathing</li>
                  <li>Footing</li>
                  <li>Foundation/ backfill</li>
                  <li>Final Building</li>
                </ul>
              </div>
            </div>
            <div className={styles.main_card}>
              <img className={styles.short_img} src={plumb1} />
              <div className={styles.elec}>
                <p>Plumbing</p>
                <ul>
                  <li>Rough Plumbing</li>
                  <li>Final Plumbing</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        {/* <div className={styles.main_wrapper}>
          <div className={styles.heading}>
            <p className={styles.head}>_______ Categories _______</p>
            <span>
              Fulfilling all of your construction code
              <br /> inspection needs
            </span>
          </div>
          <Row className={`${"mt-5"} ${styles.main_div}`}>
            <Col md={6} lg={4}>
              {" "}
              <div className={styles.six_slides}>
                <img className={styles.hover_img} src={electrical1} />

                <div className={styles.divP}>Electrical</div>
                <div className={styles.HoverEffect}>
                  <div className={styles.electrical}>
                    <img className={styles.short_img} src={elec1} />
                    <div className={styles.elec}>
                      <p>Electrical</p>
                      <ol>
                        <li>Rough Electric & Service</li>
                        <li>Final Electric</li>
                      </ol>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            <Col className={styles.margin_} md={6} lg={4}>
              <div className={styles.six_slides}>
                <div>
                  <img className={styles.hover_img} src={eng2} />
                </div>
                <div className={styles.divP}>Engineering</div>
                <div className={styles.HoverEffect}>
                  <div className={styles.electrical}>
                    <img className={styles.short_img} src={eng1} />
                    <div className={styles.elec}>
                      <p>Engineering</p>
                      <ol>
                        <li>Frame</li>
                        <li>Insulation</li>
                      </ol>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            <Col className={styles.margin_} md={6} lg={4}>
              {" "}
              <div className={styles.six_slides}>
                <img className={styles.hover_img} src={fire1} />
                <div className={styles.divP}>Fire</div>
                <div className={styles.HoverEffect}>
                  <div className={styles.electrical}>
                    <img className={styles.short_img} src={fir1} />
                    <div className={styles.elec}>
                      <p>Fire</p>
                      <ol>
                        <li>Final Fire</li>
                        <li>Rough Fire</li>
                      </ol>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            {window.innerWidth >= 768 && window.innerWidth <= 992 && (
              <>
                <Col className={styles.margin_} md={6} lg={4}>
                  {" "}
                  <div className={styles.six_slides}>
                    <div>
                      <img className={styles.hover_img} src={building1} />
                    </div>
                    <div className={styles.divP}>Building</div>
                    <div className={styles.HoverEffect}>
                      <div className={styles.electrical}>
                        <img className={styles.short_img} src={build1} />
                        <div className={styles.elec}>
                          <p>Building</p>
                          <ol>
                            <li>Footing</li>
                            <li>Foundation/ backfill</li>
                            <li>Final Building</li>
                          </ol>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col className={styles.margin_} md={6} lg={4}>
                  <div className={styles.six_slides}>
                    <img className={styles.hover_img} src={img} />
                    <div className={styles.divP}>Plumbing</div>
                    <div className={styles.HoverEffect}>
                      <div className={styles.electrical}>
                        <img className={styles.short_img} src={plumb1} />
                        <div className={styles.elec}>
                          <p>Plumbing</p>
                          <ol>
                            <li>Slab</li>
                            <li>Sheathing</li>
                            <li>Rough Plumbing</li>
                            <li>Final Plumbing</li>
                          </ol>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              </>
            )}
          </Row>
          {(window.innerWidth <= 767 || window.innerWidth >= 993) && (
            <Row className="justify-content-md-center">
              <Col className="mt-5" md={6} lg={4}>
                {" "}
                <div className={styles.six_slides}>
                  <div>
                    <img className={styles.hover_img} src={building1} />
                  </div>
                  <div className={styles.divP}>Building</div>
                  <div className={styles.HoverEffect}>
                    <div className={styles.electrical}>
                      <img className={styles.short_img} src={build1} />
                      <div className={styles.elec}>
                        <p>Building</p>
                        <ol>
                          <li>Footing</li>
                          <li>Foundation/ backfill</li>
                          <li>Final Building</li>
                        </ol>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col className="mt-5" md={6} lg={4}>
                <div className={styles.six_slides}>
                  <img className={styles.hover_img} src={img} />
                  <div className={styles.divP}>Plumbing</div>
                  <div className={styles.HoverEffect}>
                    <div className={styles.electrical}>
                      <img className={styles.short_img} src={plumb1} />
                      <div className={styles.elec}>
                        <p>Plumbing</p>
                        <ol>
                          <li>Slab</li>
                          <li>Sheathing</li>
                          <li>Rough Plumbing</li>
                          <li>Final Plumbing</li>
                        </ol>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          )}
        </div> */}
      </Container>
    </div>
  );
};
export default Six;
